<template>
  <b-card no-body>
    <b-card-header role="tab" class="card-header" :aria-expanded="active">
      <a
        data-toggle="collapse"
        data-parent="#accordion"
        :href="`#${itemId}`"
        @click.prevent="activate"
        :aria-controls="`content-${itemId}`"
        class="d-flex justify-content-between align-items-center"
      >
        <slot name="title">
          <h5 class="text-uppercase font-weight-bold mb-0">
            <span class="text-exitos">{{ title }}</span>
            <span class="text-gray">· {{ subtitle }}</span>
          </h5>
        </slot>
        <font-awesome-icon :icon="`chevron-${active ? 'up' : 'down'}`" class="text-gray" />
      </a>
    </b-card-header>

    <collapse-transition :duration="animationDuration">
      <div
        v-show="active"
        :id="`content-${itemId}`"
        role="tabpanel"
        :aria-labelledby="title"
        class="collapsed"
      >
        <div class="card-body">
          <slot></slot>
        </div>
      </div>
    </collapse-transition>
  </b-card>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  name: "collapse-item",
  components: { CollapseTransition },
  props: {
    title: {
      type: String,
      default: "",
      description: "Collapse item title",
    },
    subtitle: {
      type: String,
      default: "",
      description: "Collapse item subtitle",
    },
    id: String,

    /**
     * Permite definir se o item começa aberto.
     * Exemplo: <collapse-item :default-active="true" />
     */
    defaultActive: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    animationDuration: { default: 250 },
    multipleActive: { default: false },
  },
  computed: {
    itemId() {
      return this.id || this.title;
    },
  },
  data() {
    return {
      active: this.defaultActive, // inicia conforme a prop
    };
  },
  methods: {
    activate() {
      this.active = !this.active;
      this.$emit("update:active", this.active); // opcional: emite evento de mudança
    },
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
};
</script>

<style></style>
